export default "__VITE_ASSET__DvqvxsOY__"